// Lab51 
function outerHeight(el) {
  const style = getComputedStyle(el);

  return (
    el.getBoundingClientRect().height +
    parseFloat(style.marginTop) +
    parseFloat(style.marginBottom)
  );
}
function getPaddingTop(element) {
  const styles = window.getComputedStyle(element);
  return parseFloat(styles.paddingTop);
}
function moveCartFooter() {
  const casiGratis = document.querySelector('.casiGratis');
  const precheck = document.querySelector('.pre-check');
  const mainCartFooter = document.querySelector('#main-cart-footer');
  const cartItemsElement = document.querySelector('.cart-items');
  let paddingTop, casiGratisHeight, precheckHeight; 
  if (cartItemsElement) {
    paddingTop = getPaddingTop(cartItemsElement) + 120;
  } else {
    paddingTop = 0;
  }
  if (casiGratis) {
    casiGratisHeight = casiGratis.offsetHeight;
  } else {
    casiGratisHeight = 0;
  }
  if (precheck) {
    precheckHeight = precheck.offsetHeight;
  } else {
    precheckHeight = 0;
  }
  if (mainCartFooter) {
    mainCartFooter.style.top = `${casiGratisHeight + precheckHeight + paddingTop}px`;
  }
  //console.log({ casiGratisHeight, precheckHeight, paddingTop });
}
// Lab51 End
class CartRemoveButton extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('click', (event) => {
      event.preventDefault();
      const cartItems = this.closest('cart-items') || this.closest('cart-drawer-items');
      cartItems.updateQuantity(this.dataset.index, 0);
    });
    // Lab51 
    // console.log('test 4');
    if (typeof updateFreeShippingPrice === 'function') {
      updateFreeShippingPrice();
    }
    moveCartFooter();
    if (typeof wrapPacks === 'function') {
      wrapPacks();
    }
    if (typeof wrapPacksDrawer === 'function') {
      wrapPacksDrawer();
    }
    // Lab51 End 
  }
}

customElements.define('cart-remove-button', CartRemoveButton);

class CartItems extends HTMLElement {
  constructor() {
    super();
    this.lineItemStatusElement =
      document.getElementById('shopping-cart-line-item-status') || document.getElementById('CartDrawer-LineItemStatus');

    const debouncedOnChange = debounce((event) => {
      this.onChange(event);
      // Lab51 
      console.log('test 1');
      // Lab51 End
    }, ON_CHANGE_DEBOUNCE_TIMER);

    this.addEventListener('change', debouncedOnChange.bind(this));
  }

  cartUpdateUnsubscriber = undefined;

  connectedCallback() {
    this.cartUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => {
      if (event.source === 'cart-items') {
        return;
      }
      this.onCartUpdate();
    });
  }

  disconnectedCallback() {
    if (this.cartUpdateUnsubscriber) {
      this.cartUpdateUnsubscriber();
    }
  }

  onChange(event) {
    // Lab51: se agrega la condición para detectar la clase
    if (event.target.className === 'quantity__input') {
      this.updateQuantity(event.target.dataset.index, event.target.value, document.activeElement.getAttribute('name'), event.target.dataset.quantityVariantId);
    }
    // Lab51 
    console.log('test 3');
    if (typeof updateFreeShippingPrice === 'function') {
      updateFreeShippingPrice();
    }
    moveCartFooter();
    // Lab51 End
  }

  onCartUpdate() {
    if (this.tagName === 'CART-DRAWER-ITEMS') {
      fetch(`${routes.cart_url}?section_id=cart-drawer`)
        .then((response) => response.text())
        .then((responseText) => {
          const html = new DOMParser().parseFromString(responseText, 'text/html');
          const selectors = ['cart-drawer-items', '.cart-drawer__footer'];
          for (const selector of selectors) {
            const targetElement = document.querySelector(selector);
            const sourceElement = html.querySelector(selector);
            if (targetElement && sourceElement) {
              targetElement.replaceWith(sourceElement);
            }
          }
        })
        .catch((e) => {
          console.error(e);
        });
    } else {
      fetch(`${routes.cart_url}?section_id=main-cart-items`)
        .then((response) => response.text())
        .then((responseText) => {
          const html = new DOMParser().parseFromString(responseText, 'text/html');
          const sourceQty = html.querySelector('cart-items');
          this.innerHTML = sourceQty.innerHTML;
        })
        .catch((e) => {
          console.error(e);
        });
    }
    console.log('test update');
  }

  getSectionsToRender() {
    return [
      {
        id: 'main-cart-items',
        section: document.getElementById('main-cart-items').dataset.id,
        selector: '.js-contents',
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section',
      },
      {
        id: 'cart-live-region-text',
        section: 'cart-live-region-text',
        selector: '.shopify-section',
      },
      {
        id: 'main-cart-footer',
        section: document.getElementById('main-cart-footer').dataset.id,
        selector: '.js-contents',
      },
    ];
  }

  updateQuantity(line, quantity, name, variantId) {
    this.enableLoading(line);

    const body = JSON.stringify({
      line,
      quantity,
      sections: this.getSectionsToRender().map((section) => section.section),
      sections_url: window.location.pathname,
    });

    fetch(`${routes.cart_change_url}`, { ...fetchConfig(), ...{ body } })
      .then((response) => {
        return response.text();
      })
      .then((state) => {
        const parsedState = JSON.parse(state);
        const quantityElement =
          document.getElementById(`Quantity-${line}`) || document.getElementById(`Drawer-quantity-${line}`);
        const items = document.querySelectorAll('.cart-item');

        if (parsedState.errors) {
          quantityElement.value = quantityElement.getAttribute('value');
          this.updateLiveRegions(line, parsedState.errors);
          return;
        }

        this.classList.toggle('is-empty', parsedState.item_count === 0);
        const cartDrawerWrapper = document.querySelector('cart-drawer');
        const cartFooter = document.getElementById('main-cart-footer');

        if (cartFooter) cartFooter.classList.toggle('is-empty', parsedState.item_count === 0);
        if (cartDrawerWrapper) cartDrawerWrapper.classList.toggle('is-empty', parsedState.item_count === 0);

        // Lab51 
        console.log('test 6');
        moveCartFooter();
        if (typeof updateFreeShippingPrice === 'function') {
          updateFreeShippingPrice();
        }
        function fadeOutJs(el, time) {
          el.style.opacity = 1;
      
          (function fade() {
              if ((el.style.opacity -= (1 / time) * 50) < 0) {
                  el.style.display = 'none';
              } else {
                  requestAnimationFrame(fade);
              }
          })();
        }
        var elements = document.querySelectorAll('#main-cart-items .tr-loader');
        elements.forEach(function(el) {
            fadeOutJs(el, 100);
        });
        if (typeof mostrarDespachos === 'function') {
          $('#main-cart-items .tr-loader').fadeOut(100);
          setTimeout(function () {
            mostrarDespachos();
            loadTimes(header_region);
          }, 500);
        }
        if (typeof maxTime === 'function') {
          setTimeout(function () {
            maxTime(header_region);
          }, 500);
        }
        if (typeof loadTimes === 'function') {
          setTimeout(function () {
            loadTimes(header_region);
          }, 1000);
        }
        // Lab51 End

        this.getSectionsToRender().forEach((section) => {
          const elementToReplace =
            document.getElementById(section.id).querySelector(section.selector) || document.getElementById(section.id);
          elementToReplace.innerHTML = this.getSectionInnerHTML(
            parsedState.sections[section.section],
            section.selector
          );
        });
        const updatedValue = parsedState.items[line - 1] ? parsedState.items[line - 1].quantity : undefined;
        let message = '';
        if (items.length === parsedState.items.length && updatedValue !== parseInt(quantityElement.value)) {
          if (typeof updatedValue === 'undefined') {
            message = window.cartStrings.error;
          } else {
            message = window.cartStrings.quantityError.replace('[quantity]', updatedValue);
          }
        }
        this.updateLiveRegions(line, message);

        const lineItem =
          document.getElementById(`CartItem-${line}`) || document.getElementById(`CartDrawer-Item-${line}`);
        if (lineItem && lineItem.querySelector(`[name="${name}"]`)) {
          cartDrawerWrapper
            ? trapFocus(cartDrawerWrapper, lineItem.querySelector(`[name="${name}"]`))
            : lineItem.querySelector(`[name="${name}"]`).focus();
        } else if (parsedState.item_count === 0 && cartDrawerWrapper) {
          trapFocus(cartDrawerWrapper.querySelector('.drawer__inner-empty'), cartDrawerWrapper.querySelector('a'));
        } else if (document.querySelector('.cart-item') && cartDrawerWrapper) {
          trapFocus(cartDrawerWrapper, document.querySelector('.cart-item__name'));
        }

        publish(PUB_SUB_EVENTS.cartUpdate, { source: 'cart-items', cartData: parsedState, variantId: variantId });
      })
      .catch(() => {
        //this.querySelectorAll('.loading__spinner').forEach((overlay) => overlay.classList.add('hidden'));
        const errors = document.getElementById('cart-errors') || document.getElementById('CartDrawer-CartErrors');
        errors.textContent = window.cartStrings.error;
      })
      .finally(() => {
        this.disableLoading(line);
      });
  }

  updateLiveRegions(line, message) {
    const lineItemError =
      document.getElementById(`Line-item-error-${line}`) || document.getElementById(`CartDrawer-LineItemError-${line}`);
    if (lineItemError) lineItemError.querySelector('.cart-item__error-text').innerHTML = message;

    this.lineItemStatusElement.setAttribute('aria-hidden', true);

    const cartStatus =
      document.getElementById('cart-live-region-text') || document.getElementById('CartDrawer-LiveRegionText');
    cartStatus.setAttribute('aria-hidden', false);

    setTimeout(() => {
      cartStatus.setAttribute('aria-hidden', true);
    }, 1000);
  }

  getSectionInnerHTML(html, selector) {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
  }

  enableLoading(line) {
    const mainCartItems = document.getElementById('main-cart-items') || document.getElementById('CartDrawer-CartItems');
    mainCartItems.classList.add('cart__items--disabled');

    const cartItemElements = this.querySelectorAll(`#CartItem-${line} .loading__spinner`);
    const cartDrawerItemElements = this.querySelectorAll(`#CartDrawer-Item-${line} .loading__spinner`);

    [...cartItemElements, ...cartDrawerItemElements].forEach((overlay) => overlay.classList.remove('hidden'));

    document.activeElement.blur();
    this.lineItemStatusElement.setAttribute('aria-hidden', false);
  }

  disableLoading(line) {
    const mainCartItems = document.getElementById('main-cart-items') || document.getElementById('CartDrawer-CartItems');
    mainCartItems.classList.remove('cart__items--disabled');

    const cartItemElements = this.querySelectorAll(`#CartItem-${line} .loading__spinner`);
    const cartDrawerItemElements = this.querySelectorAll(`#CartDrawer-Item-${line} .loading__spinner`);

    cartItemElements.forEach((overlay) => overlay.classList.add('hidden'));
    cartDrawerItemElements.forEach((overlay) => overlay.classList.add('hidden'));
  }
}

customElements.define('cart-items', CartItems);

if (!customElements.get('cart-note')) {
  customElements.define(
    'cart-note',
    class CartNote extends HTMLElement {
      constructor() {
        super();

        this.addEventListener(
          'change',
          debounce((event) => {
            const body = JSON.stringify({ note: event.target.value });
            fetch(`${routes.cart_update_url}`, { ...fetchConfig(), ...{ body } });
          }, ON_CHANGE_DEBOUNCE_TIMER)
        );
      }
    }
  );
}

// Cart Footer top Lab51

document.addEventListener('DOMContentLoaded', function() {
  moveCartFooter();

  document.body.addEventListener('click', function(e) {
    if (e.target && e.target.matches('.agregar-upsell')) {
      e.preventDefault();
      console.log('clicky clicky');
      
      // Obteniendo el valor del atributo 'data-varid' del elemento clicado
      let varId = e.target.getAttribute('data-varid');
  
      fetch('/cart/add.js', {
        method: "POST",
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          quantity: 1,
          id: varId
        })
      })
      .then(response => {
        if (response.ok) {
          console.log('success');
          location.reload();
        } else {
          console.log('error ' + response.status);
        }
      })
      .catch(error => {
        console.log('error', error);
      });
    }
  });
});

window.addEventListener('load', function() {
  moveCartFooter();
});

window.addEventListener('resize', function() {
  moveCartFooter();
});

// Packs

function formatToChileanPeso(number) {
  return "$" + number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
}

function wrapPacks() {
  $('.cart__items tbody tr[data-id="pack"]').each(function(){
    var proiden = $(this).data('packid');
  });

  var $tr   = $('.cart__items tbody tr[data-id="pack"]'),
      items = {};

  $tr.each(function() {
    items[$(this).data('packid')] = '';
  });

  for (item in items) {
    $tr.filter('[data-packid='+ item +']').first().addClass('primero').append('<td class="quitar quitar' + item + '" data-quitar="' + item + '"><span><i><svg xmlns="http://www.w3.org/2000/svg" width="6.569" height="6.781" viewBox="0 0 6.569 6.781"><path id="Trazado_21267" data-name="Trazado 21267" d="M.461-5.407H3.278v.943H.461v2.912h-.95V-4.464h-2.8v-.943h2.8V-8.333h.95Z" transform="translate(3.292 8.333)" fill="#fff"/></svg></i></span></p>').stop();
    $tr.filter('[data-packid='+ item +']').last().addClass('ultimo');
    let totalPriceRaw = 0;
    $tr.filter('[data-packid='+ item +']').each(function(){
      $(this).find('.cart-item__quantity input').attr('disabled', 'disabled');
      let itemQt = $(this).find('.cart-item__quantity input').val();
      let itemPriceRaw = $(this).find('.cart-item-price').data('priceraw');
      let itemTotalPriceRaw = itemQt * itemPriceRaw;
      totalPriceRaw += itemTotalPriceRaw;
    });
    totalPriceRaw = totalPriceRaw / 100;
    let packTotalPrice = formatToChileanPeso(totalPriceRaw);
    $tr.filter('[data-packid='+ item +']').first().find('.cart-item__totals .price--end').text(packTotalPrice);
  }

  $('.cart__items tbody tr[data-id="pack"] td.quitar').on('click', function(){
    var toRemove   = $(this).data('quitar');
    var qty        = 0;
    var data       = { updates: {} };
    var itemsArray = $('.cart__items tbody tr[data-packid="' + toRemove + '"]').map(function(i,v){
      return $(v).data('item');
    }).get();
    for (i = 0; i < itemsArray.length; i++) {
      data.updates[itemsArray[i]] = qty;
    }
    jQuery.post('/cart/update.js',
      data
    ).always(function() {
      location.reload();
    });
  });
  //console.log('wrapPacks');
}

function wrapPacksDrawer() {
  $('.cart-drawer .cart-items tbody tr[data-id="pack"]').each(function(){
    var proiden = $(this).data('packid');
  });

  var $tr   = $('.cart-drawer .cart-items tbody tr[data-id="pack"]'),
      items = {};

  $tr.each(function() {
    items[$(this).data('packid')] = '';
  });

  for (item in items) {
    $tr.filter('[data-packid='+ item +']').first().addClass('primero').append('<td class="quitar quitar' + item + '" data-quitar="' + item + '"><span><i><svg xmlns="http://www.w3.org/2000/svg" width="6.569" height="6.781" viewBox="0 0 6.569 6.781"><path id="Trazado_21267" data-name="Trazado 21267" d="M.461-5.407H3.278v.943H.461v2.912h-.95V-4.464h-2.8v-.943h2.8V-8.333h.95Z" transform="translate(3.292 8.333)" fill="#fff"/></svg></i></span></p>');
    $tr.filter('[data-packid='+ item +']').last().addClass('ultimo');
    let totalPriceRaw = 0;
    $tr.filter('[data-packid='+ item +']').each(function(){
      $(this).find('.cart-item__quantity input').attr('disabled', 'disabled');
      let itemQt = $(this).find('.cart-item__quantity input').val();
      let itemPriceRaw = $(this).find('.cart-item__details').data('priceraw');
      let itemTotalPriceRaw = itemQt * itemPriceRaw;
      totalPriceRaw += itemTotalPriceRaw;
    });
    totalPriceRaw = totalPriceRaw / 100;
    let packTotalPrice = formatToChileanPeso(totalPriceRaw);
    $tr.filter('[data-packid='+ item +']').first().find('.cart-item__totals .price--end').text(packTotalPrice);
  }

  $('.cart-drawer .cart-items tbody tr[data-id="pack"] td.quitar').on('click', function(){
    var toRemove   = $(this).data('quitar');
    var qty        = 0;
    var data       = { updates: {} };
    var itemsArray = $('.cart-drawer .cart-items tbody tr[data-packid="' + toRemove + '"]').map(function(i,v){
      return $(v).data('item');
    }).get();
    for (i = 0; i < itemsArray.length; i++) {
      data.updates[itemsArray[i]] = qty;
    }
    jQuery.post('/cart/update.js',
      data
    ).always(function() {
      //location.reload();
      window.location.href = window.location.href + '#open-cart-drawer';
      window.location.reload();
    });
  });
  //console.log('wrapPacksDrawer');
}